import React, { useState } from "react";
import toast from "react-hot-toast";
import { getCurrentFYByDate } from "../../Utilitie";

const NKJTrafficFlowIns = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [globalDate, setGlobalDate] = useState(
    new Date().toISOString().slice(0, 7),
  );
  const fyData = getCurrentFYByDate(globalDate) || {};

  const [entries, setEntries] = useState([
    {
      kmz: "",
      jbp: "",
      sta: "",
      sgrl: "",
      sec: "",
      total: "",
    },
  ]);

  const keys = ["kmz", "jbp", "sta", "sgrl", "sec", "total"];
  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;

        const updated = { ...row };
        updated[key] = Number(value) || 0;

        const kmz = Number(updated.kmz) || 0;
        const jbp = Number(updated.jbp) || 0;
        const sta = Number(updated.sta) || 0;
        const sgrl = Number(updated.sgrl) || 0;
        const sec = Number(updated.sec) || 0;

        const total = Math.abs(kmz + jbp + sta + sgrl + sec);
        updated.total = total;

        return updated;
      }),
    );
  };

  const addRow = () => {
    setEntries((prev) => [
      ...prev,
      {
        kmz: "",
        jbp: "",
        sta: "",
        sgrl: "",
        sec: "",
        total: "",
      },
    ]);
  };

  const removeRow = (index) =>
    setEntries((prev) => prev.filter((_, i) => i !== index));
  const handleClear = () => setEntries([]);

  const handleSubmit = async () => {
    const dataToSend = entries.map((entry) => ({
      ...entry,
      f_year: fyData.FY.replace("_", "-") || "",
      a_year: globalDate?.slice(0, 4),
      a_month: fyData.month.toUpperCase() || "",
    }));
    try {
      const response = await fetch(`${urlPrefix}insert/nkj_trafic_flow`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result?.message || "HTTP error");

      toast.success("✅ Data uploaded successfully!");
      setEntries([
        {
          kmz: "",
          jbp: "",
          sta: "",
          sgrl: "",
          sec: "",
          total: "",
        },
      ]);
    } catch (error) {
      toast.error("❌ Failed to upload data");
      console.error("Upload error:", error);
    }
  };

  const handleDateChange = (value) => {
    setGlobalDate(value);
  };

  return (
    <div className="papaDiv">
      <h5 className="p-2 bg-dark text-white text-center">
        Insert Data in Traffic Flow
      </h5>

      <div className="d-flex justify-content-center align-items-center gap-3 m-3">
        <div>
          <label className="fw-bold me-2">Select Date:</label>
          <input
            type="month"
            className="form-control d-inline-block"
            style={{ width: "180px", fontSize: "0.9rem" }}
            value={globalDate}
            onChange={(e) => handleDateChange(e.target.value)}
          />
        </div>
        <div>
          <span className="badge bg-primary me-2">
            FY: {fyData.FY.replace("_", "-") || "N/A"}
          </span>
          <span className="badge bg-success">
            Month: {fyData.month || "N/A"}
          </span>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              {keys.map((key, i) => (
                <th key={i}>{key.replace(/_/g, " ").toUpperCase()}</th>
              ))}
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {entries.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {keys.map((key, index) => (
                  <td key={index}>
                    {key === "total" ? (
                      <input
                        disabled
                        type="number"
                        className="form-control"
                        value={row[key] || ""}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="number"
                        className="form-control"
                        style={{ width: "140px", fontSize: "0.8rem" }}
                        value={row[key] || ""}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}

                <td>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => removeRow(rowIndex)}
                  >
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center mt-3">
        <button className="btn btn-outline-primary m-2" onClick={addRow}>
          Add Row
        </button>
        <button className="btn btn-outline-danger m-2" onClick={handleClear}>
          Clear
        </button>
        <button className="btn btn-outline-success m-2" onClick={handleSubmit}>
          Upload
        </button>
      </div>
    </div>
  );
};

export default NKJTrafficFlowIns;
